import { createStore, applyMiddleware, compose } from 'redux';
import { createBrowserHistory } from 'history';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import createRootReducer from './config';
import { refreshToken } from './config/user';
import { setInitialCompanyFormState } from './config/companystats';
import { setInitialLeadsFormState } from './config/leadsstats';
import { setInitialSearchFormState } from './config/searchstats';
import { setInitialCompanyReportFormState } from './config/companyreport';
import { setInitialImpressionState } from './config/impressionstats';
import routeConstants from '../Routes/routeConstants';
import authService from '../services/authService';


const isDevelopment = process.env.NODE_ENV === 'development';
const composeEnhancers = isDevelopment
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    : compose;

export const history = createBrowserHistory();

// export default store;
export default function configureStore() {
    const store = createStore(
        createRootReducer(history),
        composeEnhancers(
            applyMiddleware(
                routerMiddleware(history), // for dispatching history actions
                thunk,
            ),
        ),
    );

    // refresh access token if present
    store.dispatch(refreshToken());

    // eventlistners for token refresh on tab change
    document.removeEventListener('visibilitychange', authService.refresh);
    document.addEventListener('visibilitychange', authService.refresh);

    // use location to parse correspondoing form state
    const { location } = history;
    const { pathname } = location;
    switch (pathname) {
    case routeConstants.COMPANY_STATS:
        store.dispatch(setInitialCompanyFormState(location));
        break;
    case routeConstants.LEADS_STATS:
        store.dispatch(setInitialLeadsFormState(location));
        break;
    case routeConstants.IMPRESSION_STATS:
        store.dispatch(setInitialImpressionState(location));
        break;
    case routeConstants.SEARCH_STATS:
        store.dispatch(setInitialSearchFormState(location));
        break;
    case routeConstants.COMPANY_REPORT:
        store.dispatch(setInitialCompanyReportFormState(location));
        break;
    default:
        break;
    }

    return store;
}
